module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f8f8f8",
      "border-top": "2px solid #fea923"
    }
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "top-wrap"
  }, [_c('div', {
    staticClass: "category-box",
    on: {
      "mouseleave": _vm.popupClose
    }
  }, [_c('div', {
    staticClass: "category-list"
  }, _vm._l((_vm.listCategoriesArr), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: item.id,
            levelOneText: item.name,
            levelTwo: '',
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: '',
          },
        }
      }
    }, [_c('div', {
      staticClass: "category-li",
      class: item.active == true ? 'active' : '',
      on: {
        "mouseenter": function($event) {
          return _vm.popupInit(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n              "), _c('i', {
      staticClass: "el-icon-arrow-right category-right-icon"
    })])])
  }), 1), _vm._v(" "), (_vm.showCategoryDetail == true) ? _c('div', {
    staticClass: "category-detail main-popup"
  }, [_c('div', _vm._l((_vm.listCategoriesArr2), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "main-popup-item"
    }, [_c('div', {
      staticClass: "main-popup-category"
    }, [_c('router-link', {
      attrs: {
        "tag": "a",
        "to": {
          name: 'Category',
          query: {
            levelOne: item.parentId,
            levelOneText: item.name2,
            levelTwo: item.id,
            levelTwoText: item.name,
            levelThree: '',
            keyWord: '',
            selectType: '',
            brandId: '',
          },
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('ul', {
      staticClass: "main-popup-category-child"
    }, _vm._l((item.categories), function(itm, idx) {
      return _c('li', {
        key: idx,
        staticClass: "category-detail-li"
      }, [_c('router-link', {
        staticClass: "cdl",
        attrs: {
          "tag": "a",
          "to": {
            name: 'Category',
            query: {
              levelOne: item.parentId,
              levelOneText: item.name2,
              levelTwo: itm.parentId,
              levelTwoText: item.name,
              levelThree: itm.id,
              levelThreeText: itm.name,
              keyWord: '',
              selectType: '',
              brandId: '',
            },
          }
        }
      }, [_vm._v(_vm._s(itm.name))])], 1)
    }), 0)])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "carousel-box"
  }, [_c('el-carousel', {
    attrs: {
      "height": "400px"
    }
  }, _vm._l((_vm.listCirculationPicturesArr), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.activity
      }
    }, [_c('div', {
      staticClass: "carousel-img",
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    })])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "account-box"
  }, [_c('div', {
    staticClass: "main-photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.logoPath
    },
    on: {
      "error": function($event) {
        return _vm.error(4)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-name"
  }, [_vm._v("\n          HI，"), _c('span', [_vm._v(_vm._s(_vm.accountInfo.account))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center",
      "color": "#333"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.headerName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999",
      "text-align": "center",
      "margin-bottom": "20px",
      "margin-top": "10px",
      "cursor": "pointer"
    }
  }, [_c('span', {
    on: {
      "click": _vm.layout
    }
  }, [_vm._v("退出登录")])]), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list-num"
  }, [_vm._v("\n            " + _vm._s(_vm.accountInfo.enterBrandCount) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list-num"
  }, [_vm._v("\n            " + _vm._s(_vm.accountInfo.enterSKUCount) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "account-detail-list-num"
  }, [_vm._v("\n            " + _vm._s(_vm.accountInfo.enterPlatformCount) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "recommend-wrap"
  }, _vm._l((_vm.smallSerialListArr), function(ele, iii) {
    return _c('section', {
      key: iii,
      staticClass: "recommend-box"
    }, [_c('div', [(ele.jumpStyle == '1') ? _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": ele.coverImgpath,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (ele.jumpStyle == '3') ? _c('a', {
      attrs: {
        "href": ele.jumpTo,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "cursor": "pointer"
      },
      attrs: {
        "src": ele.coverImgpath,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (ele.jumpStyle == '4') ? _c('router-link', {
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'Recommend',
          query: {
            serialId: ele.id
          }
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "cursor": "pointer"
      },
      attrs: {
        "src": ele.coverImgpath,
        "alt": ""
      }
    })]) : _vm._e()], 1), _vm._v(" "), (ele.goodsObj) ? _c('div', [_c('div', {
      staticClass: "category-goods-wrap"
    }, [_c('ul', {
      staticClass: "category-goods-list"
    }, _vm._l((ele.goodsObj.goodsList), function(item, index) {
      return (index < ele.showLength) ? _c('li', {
        key: index,
        staticClass: "category-goods-item",
        staticStyle: {
          "background-color": "#fff",
          "height": "380px"
        }
      }, [_c('div', {
        staticClass: "category-goods-image"
      }, [_c('router-link', {
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'Detail',
            query: {
              goodsId: item.responseAppGoodsVo.goodsId
            },
          }
        }
      }, [_c('div', {
        staticClass: "recommend-image",
        style: ({
          backgroundImage: 'url(' +
            _vm.imgAddress +
            item.responseAppGoodsVo.goodsImage +
            ')',
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "category-cover-image",
        class: {
          a: item.responseAppGoodsVo.isBill == 1
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "category-hover-product"
      }, [_c('table', {
        attrs: {
          "border": "0",
          "cellspacing": "0",
          "cellpadding": "0"
        }
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SKU")]), _vm._v(" "), _c('th', [(item.responseAppGoodsVo.isBill == 0) ? _c('span', [_vm._v("\n                                不带票结算价\n                                "), (item.responseAppGoodsVo.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()]) : _c('span', [_vm._v("\n                                带票结算价\n                                "), (item.responseAppGoodsVo.supplyChannel == 1) ? _c('span', [_vm._v("(+运费)")]) : _vm._e()])]), _vm._v(" "), _c('th', [_vm._v("库存")])])]), _vm._v(" "), _c('tbody', _vm._l((item.responseAppGoodsVo.products), function(itm, idx) {
        return (idx < 7) ? _c('tr', {
          key: idx
        }, [_c('td', {
          staticClass: "category-table-SKU"
        }, [_c('div', [_vm._v(_vm._s(itm.specName))])]), _vm._v(" "), _c('td', [(item.responseAppGoodsVo.isBill == 0) ? _c('span', [_vm._v("\n                                " + _vm._s(itm.settlementPrice / 100) + "\n                                "), (item.responseAppGoodsVo.supplyChannel == 1) ? _c('span', {
          staticClass: "freight-price"
        }, [_vm._v("(+" + _vm._s(itm.freight / 100) + ")")]) : _vm._e()]) : _c('span', [_vm._v("\n                                " + _vm._s(itm.settlementPrice / 100) + "\n                                "), (item.responseAppGoodsVo.supplyChannel == 1) ? _c('span', {
          staticClass: "freight-price"
        }, [_vm._v("(+" + _vm._s(itm.freight / 100) + ")")]) : _vm._e()])]), _vm._v(" "), _c('td', [(item.responseAppGoodsVo.isBill == 0) ? _c('span', [_vm._v(_vm._s(itm.inventoryNum))]) : _c('span', [_vm._v(_vm._s(itm.inventoryNum))])])]) : _vm._e()
      }), 0)])])])], 1), _vm._v(" "), _c('div', {
        staticClass: "category-goods-info"
      }, [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": item.responseAppGoodsVo.goodsName,
          "placement": "top"
        }
      }, [_c('div', {
        staticClass: "category-goods-title2"
      }, [_vm._v("\n                      " + _vm._s(item.responseAppGoodsVo.goodsName) + "\n                    ")])]), _vm._v(" "), _c('div', {
        staticClass: "category-goods-type"
      }, [(
        item.responseAppGoodsVo.supplyChannel == 2 ||
        item.responseAppGoodsVo.supplyChannel == 3
      ) ? _c('div', [_vm._v("\n                      社群集采\n                    ")]) : _vm._e(), _vm._v(" "), (item.responseAppGoodsVo.supplyChannel == 1) ? _c('div', [_vm._v("\n                      一件代发\n                    ")]) : _vm._e(), _vm._v(" "), (item.responseAppGoodsVo.isSelf == 1) ? _c('div', {
        staticStyle: {
          "background-color": "rgb(231, 249, 235)",
          "color": "rgb(88, 191, 106)"
        }
      }, [_vm._v("\n                      自产自销\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "category-goods-price2"
      }, [_c('div', [_vm._v("\n                      结算价\n                      "), _c('span', [_vm._v("\n                        ¥\n                        "), _c('span', {
        staticStyle: {
          "font-size": "18px"
        }
      }, [_vm._v(_vm._s(item.responseAppGoodsVo.originSettlementPrice / 100))])])]), _vm._v(" "), _c('div', [_vm._v("\n                      毛利率 ¥\n                      " + _vm._s((
        ((item.responseAppGoodsVo.salePrice -
            item.responseAppGoodsVo.settlementPrice) /
          item.responseAppGoodsVo.salePrice) *
        100
      ).toFixed(2) + "%") + "\n                    ")])]), _vm._v(" "), _c('div', {
        staticClass: "category-goods-price3"
      }, [_c('div', [_vm._v("\n                      建议零售价 ¥ " + _vm._s(item.responseAppGoodsVo.salePrice / 100) + "\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      毛利 ¥\n                      "), _c('span', {
        staticStyle: {
          "color": "#ff6015"
        }
      }, [_vm._v(_vm._s((
        item.responseAppGoodsVo.salePrice -
        item.responseAppGoodsVo.settlementPrice
      ).toFixed(2) / 100))])])])], 1)]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "show-more"
    }, [(ele.goodsObj.count > ele.showLength) ? _c('span', {
      on: {
        "click": function($event) {
          return _vm.showLength(iii)
        }
      }
    }, [_vm._v("更多"), _c('i', {
      staticClass: "el-icon-arrow-down"
    })]) : _vm._e()])])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "footer-wrap"
  }, _vm._l((_vm.footerImg), function(item, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": item.path,
        "alt": ""
      }
    })
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-detail-list-title"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "position": "relative",
      "top": "2px"
    },
    attrs: {
      "src": require("../assets/img/home-enterBrandCount.png"),
      "alt": ""
    }
  }), _vm._v("\n            已入驻品牌\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-detail-list-title"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "position": "relative",
      "top": "2px"
    },
    attrs: {
      "src": require("../assets/img/home-enterSKUCount.png"),
      "alt": ""
    }
  }), _vm._v("\n            已入驻SKU\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-detail-list-title"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "position": "relative",
      "top": "2px"
    },
    attrs: {
      "src": require("../assets/img/home-enterPlatformCount.png"),
      "alt": ""
    }
  }), _vm._v("\n            选货第三方\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dbf9280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 525
// module chunks = 1